export default __webpack_public_path__ + "static/media/read.e2b60a32.svg";